import { getToken } from "../../utils/request";
export default (url, reqbody) => {
  return `${url}${/\?/.test(url) ? "&" : "?"}${Object.keys(reqbody).reduce((p, c) => {
    return p + `${c}=${reqbody[c]}&`;
  }, "")}authorization=${getToken()}&systemId=${window.systemId}`;
};
